import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as suggestionsActions from 'action/suggestions'
import { isEmpty } from 'utils/validations'
import ContentHeader from 'component/utils/ContentHeader'
import SuggestionHeader from 'component/suggestion/Header'
import SuggestionFilterForm from 'component/suggestion/FilterForm'
import SuggestionTable from 'component/suggestion/Table'
import Notification from 'component/utils/Notification'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'

class SuggestionContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    error: PropTypes.object,
    updated: PropTypes.bool,
    suggestions: PropTypes.array.isRequired,
    update: PropTypes.func.isRequired,
    fetchSuggestions: PropTypes.func.isRequired,
    getSuggestion: PropTypes.func.isRequired,
    resetSuggestions: PropTypes.func.isRequired,
    resetEditSuggestions: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    saveSuggestionsFilters: PropTypes.func.isRequired,
    resetSuggestionsFilters: PropTypes.func.isRequired,
    prevPathname: PropTypes.string,
    filters: PropTypes.object,
    location: PropTypes.object,
    deleteSuggestion: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    const {
      prevPathname,
      filters: stateFilters,
      location: { pathname },
    } = props
    let filters = {}

    if (stateFilters) {
      if (prevPathname && prevPathname.includes(pathname)) {
        filters = stateFilters
      }
    }

    const smallWindow = window.innerWidth <= 768

    this.state = {
      formVisible: !smallWindow,
      tableVisible: true,
      renderButtons: false,
      filters,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.getSuggestion = this.getSuggestion.bind(this)
    this.handleFilters = this.handleFilters.bind(this)
    this.handleFetchSuggestions = this.handleFetchSuggestions.bind(this)
    this.renderNotification = this.renderNotification.bind(this)
    this.renderUpdateNotification = this.renderUpdateNotification.bind(this)
    this.invertStates = this.invertStates.bind(this)
    this.setRenderButtons = this.setRenderButtons.bind(this)
  }

  componentDidMount() {
    const { resetSuggestions, resetEditSuggestions, resetSuggestionsFilters, current } =
      this.props

    resetSuggestions()
    resetEditSuggestions()
    resetSuggestionsFilters()
    this.handleFetchSuggestions(current)
  }

  componentWillUnmount() {
    const { resetSuggestions, saveSuggestionsFilters } = this.props
    const { filters } = this.state

    resetSuggestions()
    saveSuggestionsFilters(filters)
  }

  componentWillReceiveProps() {
    const { formVisible } = this.state
    const { updated } = this.props

    if (formVisible && updated) {
      this.invertStates()
    }
  }

  setRenderButtons(value) {
    this.setState({ renderButtons: value })
  }

  invertStates() {
    if (window.innerWidth > 768) {
      this.setState({ formVisible: true, tableVisible: true })
      return
    }

    let { formVisible, tableVisible } = this.state

    formVisible = !formVisible
    tableVisible = !tableVisible

    this.setState({ formVisible, tableVisible })

    if (formVisible) {
      const { resetSuggestions } = this.props
      resetSuggestions()
    }
  }

  handleFilters(filters, current) {
    this.setState({ filters }, () => this.handleFetchSuggestions(current))
  }

  handleFetchSuggestions(page) {
    const {
      fetchSuggestions,
      auth: { user },
    } = this.props

    const filters = { ...this.state.filters }

    if (filters.dtStart) {
      filters.dtStart = filters.dtStart.format('DD/MM/YYYY')
    }
    if (filters.dtEnd) {
      filters.dtEnd = filters.dtEnd.format('DD/MM/YYYY')
    }

    fetchSuggestions(filters, user.dsToken, page)
  }

  handleSubmit(toSave, toRemove) {
    const {
      update,
      auth: { user },
    } = this.props

    update(user.dsToken, toSave, toRemove)
  }

  getSuggestion(index) {
    const { getSuggestion } = this.props

    getSuggestion(index)
  }

  renderNotification() {
    const { translate } = this.props
    return (
      <Notification
        className='notification-warning notification-warning-mission margin-top'
        message={translate('suggestion.suggestion-not-found')}
      />
    )
  }

  renderUpdateNotification() {
    const { translate } = this.props
    return (
      <Notification
        className='notification-success margin-top'
        message={translate('suggestion.update-success')}
      />
    )
  }

  renderFieldsErrors = (fields) => (
    <li className='margin-left' key={fields.naField}>
      {fields.naField ? `${fields.naField}:` : ''} {fields.dsDetail}
    </li>
  )

  handleDeleteSuggestion = async (values) => {
    const {
      auth: {
        user: { dsToken },
      },
      deleteSuggestion,
      current,
    } = this.props

    const filters = { ...this.state.filters }

    await deleteSuggestion(dsToken, values)

    this.handleFilters(filters, current)
  }

  render() {
    const {
      translate,
      error,
      suggestions,
      pages,
      count,
      current,
      updated,
      auth,
    } = this.props

    const { tableVisible, formVisible, renderButtons, filters } = this.state

    return (
      <section className='suggestion-page'>
        <ContentHeader>{translate('suggestions.title')}</ContentHeader>

        <SuggestionHeader
          translate={translate}
          pageName={translate('suggestions.title')}
        />

        <section>
          <div className='container-fluid'>
            {
              // shows notification after an update
              error && error.fields ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.fields.map(this.renderFieldsErrors)}
                </div>
              ) : error ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.message.dsMessage}
                </div>
              ) : (
                ''
              )
            }
          </div>

          <Row className='container-fluid container-mobile container-flex'>
            {formVisible && (
              <Col xs={12} sm={12} md={3} className='show-fourth-on-mobile'>
                <SuggestionFilterForm
                  translate={translate}
                  initialValues={filters}
                  error={error}
                  auth={auth}
                  invertStates={this.invertStates}
                  handleFilters={this.handleFilters}
                />
              </Col>
            )}

            {tableVisible && (
              <Col xs={12} sm={12} md={9} className='show-first-on-mobile'>
                <legend className='SuggestionTable'>
                  {translate('suggestions.list-suggestions')}
                </legend>

                {updated && this.renderUpdateNotification()}

                {isEmpty(suggestions) ? (
                  this.renderNotification()
                ) : (
                  <SuggestionTable
                    translate={translate}
                    suggestions={suggestions}
                    renderButtons={renderButtons}
                    setRenderButtons={this.setRenderButtons}
                    getSuggestion={this.getSuggestion}
                    handleDeleteSuggestion={this.handleDeleteSuggestion}
                    onSubmit={this.handleSubmit}
                    user={auth.user}
                  />
                )}
              </Col>
            )}

            {pages > 1 && tableVisible && (
              <Col className='show-second-on-mobile align-center margin-top margin-bottom-double'>
                <div className='align-center'>
                  <Pagination
                    getPage={this.handleFetchSuggestions}
                    pages={pages}
                    current={current}
                    count={count}
                  />
                </div>
              </Col>
            )}
          </Row>
        </section>
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({
  suggestionReducer,
  paginateReducer,
  routesReducer,
}) => ({
  suggestions: suggestionReducer.list.records,
  updated: suggestionReducer.edit.updated,
  error: suggestionReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  prevPathname: routesReducer.prevPathname,
  filters: suggestionReducer.filters,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(suggestionsActions, dispatch)

/*
 * Connects component to I18next
 */
const SuggestionTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(SuggestionContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuggestionTranslated)

/*
 * Exports as component
 */
export { SuggestionContainer as Suggestion }
